import Store from './store';

export default new Store();